// extracted by mini-css-extract-plugin
export default {"inputBox":"styles__inputBox--wqxhd","select":"styles__select--QlZiC styles__inputBox--wqxhd"};